import { Col, FormInstance, Row } from 'antd';
import { useIntl } from 'react-intl';
import FloatingFormItem from '../FloatingFormItem';
import { useState } from 'react';
import BrandsInfiniteSelect from '../BrandsInfiniteSelect';
import ModelsInfiniteSelect from '../ModelsInfiniteSelect';

interface Props {
  form: FormInstance<{ modelId: number; brandId: number }>;
  type?: 'update' | 'create';
}

const BrandsModelsSelect = ({ type, form }: Props) => {
  const intl = useIntl();

  const [selectedBrand, setSelectedBrand] = useState<number>();

  const handleBrandChange = (brandId?: number) => {
    setSelectedBrand(!!brandId ? brandId : undefined);

    form.resetFields(['modelId']);
  };

  return (
    <Row gutter={[24, 24]}>
      <Col span={12}>
        <FloatingFormItem
          name="brandId"
          label={intl.formatMessage({
            id: 'task.application.form.automaker',
          })}
        >
          <BrandsInfiniteSelect
            allowClear
            onChange={handleBrandChange}
            disabled={type === 'update'}
          />
        </FloatingFormItem>
      </Col>

      <Col span={12}>
        <FloatingFormItem
          name="modelId"
          label={intl.formatMessage({
            id: 'task.application.form.model',
          })}
        >
          <ModelsInfiniteSelect
            allowClear
            disabled={!selectedBrand}
            queryFilter={{ brandId: selectedBrand }}
          />
        </FloatingFormItem>
      </Col>
    </Row>
  );
};

export default BrandsModelsSelect;
